module.exports = __webpack_public_path__ + "img/reward.2e971e74.svg";